import { Checkbox } from "@rawa/ui/Checkbox"
import { fieldInstructions, fieldName } from "../fields"
import type { ControlRenderer } from "./types"

export const checkbox: ControlRenderer<"checkbox"> = {
  Render: ({ field, value, onChange, error }) => (
    <Checkbox
      checked={value ?? false}
      label={fieldName(field)}
      hint={fieldInstructions(field)}
      required={field.required}
      error={error}
      size="small"
      onChange={onChange}
    />
  ),
}
